import axiosInstance from "../../services/api/axiosInstance";
import backgroundAxiosInstance from "../../services/api/backgroundAxiosInstance";
import { ROLES, USER_ROLES } from "../constants/Constants";
export const getApiInstance = (isBackground = false) => {
    return isBackground ? backgroundAxiosInstance : axiosInstance;
}
export const formatDate = (date) => {
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1).padStart(2, "0");
  const day = String(date?.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const addMeridian = (timeString) => {
  if (!timeString || typeof timeString !== 'string') {
    return 'Invalid Time';
  }
  const [hours, minutes] = timeString.split(':');
  if (!hours || !minutes || hours.length !== 2 || minutes.length !== 2) {
    return 'Invalid Format';
  }
  const hour = parseInt(hours, 10);
  const min = parseInt(minutes, 10);
  if (hour < 0 || hour > 23 || min < 0 || min > 59) {
    return 'Invalid Time';
  }
  const meridian = hour >= 12 ? 'PM' : 'AM';
  let displayHour = hour;
  if (hour === 0) {
    displayHour = 12; 
  } else if (hour > 12) {
    displayHour = hour - 12; 
  }
  return `${displayHour}:${minutes} ${meridian}`;
};

export const userBaseRoute = (route) => {
  switch (route) {
    case ROLES.PRINCIPAL:
      return USER_ROLES.ADMIN;
    case ROLES.TEACHER:
      return USER_ROLES.TEACHER;
    case ROLES.STUDENT:
      return USER_ROLES.STUDENT;
  }
}
export const getTimeDiff = (startTime, endTime = new Date()) => {
  const diffMs = endTime - new Date(startTime); 

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours > 0) {
    return `${diffHours} hour(s) ago`;
  } else {
    return `${diffMinutes} minute(s) ago`;
  }
};


export const formatBytes=(bytes, decimals = 2)=> {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

 export const getImageFromUrl = (data) => {
  if(!data){
    return "";
  }
    const fileId = data?.match(/\/d\/(.*?)\//)?.[1];
    return `${process.env.REACT_APP_API_BASE_URL + "documents/" + fileId}`;
  }

  export const debounceFunction=(func, delay)=> {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  }
}
  export const getLogMeta = (log) => {
    const map = {
        STUDENT: { icon: "🎓", bg: "bg-purple-100" },
        TEACHER: { icon: "👨‍🏫", bg: "bg-blue-100" },
        CLASS: { icon: "🏫", bg: "bg-green-100" },
        ATTENDANCE: { icon: "📋", bg: "bg-yellow-100" },
        FEE: { icon: "💰", bg: "bg-orange-100" },
        EXAM: { icon: "📝", bg: "bg-red-100" },
        TIMETABLE: { icon: "📅", bg: "bg-indigo-100" },
    };
    return map[log.category] || { icon: "📌", bg: "bg-gray-100" };
};

export const formatTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", {
        day: "2-digit", month: "short",
        hour: "2-digit", minute: "2-digit"
    });
};
export const getSchoolShortName = (title) => {
  if (!title) return "";

  return title?.trim()?.split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + ".")
    .join("");
};


export const isMobile = () => {
  return window.innerWidth <= 768; // You can adjust the breakpoint as needed
}
export const getGreeting =()=> {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return "Good morning";
  } else if (hour >= 12 && hour < 17) {
    return "Good afternoon";
  } else if (hour >= 17 && hour < 21) {
    return "Good evening";
  } else {
    return "Good night";
  }
}
